import { useTranslation } from "@redotech/redo-i18n";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import type { ProductPropertyState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const ProductPropertyDetails = memo(function ProductPropertyDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<ProductPropertyState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  const description =
    flowType === FlowType.FINALIZE_RETURN ||
    flowType === FlowType.FINALIZE_CLAIM
      ? t("Property names to search for in all selected items")
      : undefined;

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      description={description}
      inputValue={inputValue}
      label={t('Property names/values (e.g. "Size" or "Size: Small")')}
      placeholder={t("Type and press Enter to add")}
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
